import {
    TabComponent,
    TabItemDirective,
    TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import './lladmin.scss';
import LocationSettings from './locationsettings/locationsettings';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setRowData } from '../grid/gridReducer';
import {
    setSelectedRecrdsExport,
    setTabNameForRowData,
} from '../contactTabs/contactReducer';
import { getLlAdminEndPoint } from './utils';
import axios from 'axios';
import {
    setClientsData,
    setIsLoaderShow,
    setLanguageData,
    setMsgMgmtData,
} from './lladminreducer';
import ClientIdManagament from './clientidmanagement/clientIdMgmt';
import notify from '../../services/toasterService';
import CompanyComponent from './comany-codes/company-codes';
import AdminUserManagement from './admin-users/admin-users';
import UserManagement from '../accessMgmt/usermanagement/usermanagement';
import { getAccessMgmtEndPoint } from '../accessMgmt/utils';
import {
    setRolesData,
    setRolesList,
    setUserAccessData,
} from '../accessMgmt/accessmgmtReducer';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

const parentTab = [
    { text: 'Company Codes', id: '0' },
    { text: 'Admin Users', id: '1' },
    { text: 'Client ID Management', id: '2' },
    { text: 'Location Settings', id: '3' },

    // { text: "Message Management" },
];

const LlAdmin = () => {
    const [selectedTab, setSelectedTab] = useState<string>('COMPANY_CODES');

    const dispatch = useDispatch();
    // let selectedTab: string;

    useEffect(() => {
        dispatch(setRowData([]));
        dispatch(setSelectedRecrdsExport([]));
        dispatch(setTabNameForRowData(''));
        getRoles('Roles');
    });

    // useEffect(() => {
    //     dispatch(setRowData([]));
    //     dispatch(setSelectedRecrdsExport([]));
    //     dispatch(setTabNameForRowData(''));
    //     getRoles('Roles');
    // }, []);

    // // const TabChangeEvent = async (e: any) => {
    // //     dispatch(setRowData([]));
    // //     selectedTab = e.selectingItem.innerText;

    // //     if (selectedTab !== 'Location Settings') {
    // //         if (selectedTab === 'Admin Users') {
    // //             // getAccessManagementTab(selectedTab);
    // //         } else {
    // //             await LlAdminTabApi(e.selectingItem.innerText);
    // //         }
    // //     }
    // // };

    // const getTabEvent = (e: any) => {
    //     // //console.log(e, 'On page load Tab');
    //     if (e !== null) {
    //         const selectedId = e.selectingID;
    //         //console.log(selectedId);
    //         //   childTab.map((item) => {
    //         //     if (item.id === selectedId) {
    //         //       selectedTab = item.text;
    //         //       locationSettingTabApi(selectedTab);
    //         //     }
    //         //   });
    //         // //console.log(selectedTab, 'selectedTab');
    //     }
    // };

    // /**
    //  * LL Admin Tab Change event
    //  * @author Anudeep
    //  * @param TabName - Selected Tab name
    //  */
    const LlAdminTabApi = async (TabName: any) => {
        if (TabName === 'COMPANY_CODES' || TabName === 'ADMIN_USERS' || TabName === 'LOCATION_SETTINGS') {
            return;
        }
        dispatch(setIsLoaderShow(true));
        const endPointURL = getLlAdminEndPoint(TabName);
        await axios
            .get(endPointURL)
            .then((res) => {
                dispatch(setIsLoaderShow(false));
                if (TabName === 'CLIENT_ID_MANAGEMENT') {
                    dispatch(setClientsData(res.data));
                } else if (TabName === 'Message Management') {
                    dispatch(setMsgMgmtData(res.data));
                    const endPointURL = getLlAdminEndPoint('Languages');
                    axios
                        .get(endPointURL)
                        .then((res) => {
                            dispatch(setLanguageData(res.data));
                        })
                        .catch((err) => {
                            dispatch(setIsLoaderShow(false));
                            notify(err, 'error');
                        });
                }
            })
            .catch((err) => {
                notify('Failed to fetch data', 'error');
                dispatch(setIsLoaderShow(false));
            });
    };

    // const getAccessManagementTab = async (TabName: any) => {
    //     dispatch(setIsLoaderShow(true));
    //     // const token = UserService.getToken();
    //     // //console.log(token);
    //     // const token = sessionStorage.getItem('token');
    //     const endPointURL = getAccessMgmtEndPoint('Users');

    //     // await axios.get(endPointURL, { headers: { 'Authorization': `Bearer ${token}` } }).then((res: any) => {
    //     await axios
    //         .get(endPointURL)
    //         .then((res: any) => {
    //             res.data.forEach((element: any) => {
    //                 element.companyName =
    //                     element.userCompanyMapping?.length > 0
    //                         ? element.userCompanyMapping[0]?.company
    //                               ?.companyName
    //                         : '';
    //                 if (element.userCompanyMapping?.length > 0) {
    //                     element.roleID =
    //                         element.userCompanyMapping[0]?.roleId[0] || '';
    //                 }
    //             });
    //             dispatch(setIsLoaderShow(false));
    //             dispatch(setUserAccessData(res.data));
    //             getRoles('Roles');
    //         })
    //         .catch((err) => {
    //             //console.log(err);
    //             notify(
    //                 'Error! Unable to fetch data. Please try after sometime.',
    //                 'error'
    //             );
    //             dispatch(setIsLoaderShow(false));
    //         });
    // };

    const getRoles = async (fieldName: any) => {
        dispatch(setIsLoaderShow(true));
        // const token = sessionStorage.getItem('token');
        // const token = UserService.getToken();
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        // await axios.post(getEndPointUrl, {}, { headers: { 'Authorization': `Bearer ${token}` } }).then((res: { data: any; }) => {
        await axios
            .post(getEndPointUrl, {})
            .then((res: { data: any }) => {
                dispatch(setIsLoaderShow(false));
                dispatch(setRolesData(res.data));
                dispatch(setRolesList(res.data));
            })
            .catch((err: any) => {
                dispatch(setIsLoaderShow(false));
                //console.log(err);
                notify(
                    'Error! Unable to fetch data. Please try after sometime.',
                    'error'
                );
            });
    };

    const handleTabSelection = (event: any, tab: string) => {
        try {
            dispatch(setRowData([]));
            dispatch(setSelectedRecrdsExport([]));
            var btnSet;
            const elements = document.getElementsByClassName('activeTab');
            while (elements.length > 0)
                elements[0].classList.remove('activeTab');
            if (tab === 'COMPANY_CODES') {
                btnSet = document.getElementById(
                    'btnCompanyCodes'
                ) as HTMLElement;
                btnSet.classList.add('activeTab');
            } else if (tab === 'ADMIN_USERS') {
                btnSet = document.getElementById(
                    'btnAdminUsers'
                ) as HTMLElement;
                btnSet.classList.add('activeTab');
            } else if (tab === 'CLIENT_ID_MANAGEMENT') {
                btnSet = document.getElementById(
                    'btnClientIdManagement'
                ) as HTMLElement;
                btnSet.classList.add('activeTab');
                dispatch(setRowData([]));
                dispatch(setSelectedRecrdsExport([]));
            } else if (tab === 'LOCATION_SETTINGS') {
                btnSet = document.getElementById(
                    'btnLocationSettings'
                ) as HTMLElement;
                btnSet.classList.add('activeTab');
            }
            LlAdminTabApi(tab);
            setSelectedTab(tab);
        } catch (error) {}
    };

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 parent-tab-width">
            <div className="contact-screen">
                <div className="tab-wrapper">
                    {/* <UserManagement /> */}
                    <ButtonComponent
                        className="textTransform-initial  users activeTab"
                        id="btnCompanyCodes"
                        onClick={(e) => handleTabSelection(e, 'COMPANY_CODES')}
                    >
                        Company Codes
                    </ButtonComponent>

                    <ButtonComponent
                        className="textTransform-initial  admin-users"
                        id="btnAdminUsers"
                        onClick={(e) => handleTabSelection(e, 'ADMIN_USERS')}
                    >
                        Admin Users
                    </ButtonComponent>

                    <ButtonComponent
                        className="textTransform-initial  client-id-management"
                        id="btnClientIdManagement"
                        onClick={(e) =>
                            handleTabSelection(e, 'CLIENT_ID_MANAGEMENT')
                        }
                    >
                        Client ID Management
                    </ButtonComponent>

                    <ButtonComponent
                        className="textTransform-initial  location-settings"
                        id="btnLocationSettings"
                        onClick={(e) =>
                            handleTabSelection(e, 'LOCATION_SETTINGS')
                        }
                    >
                        Location Settings
                    </ButtonComponent>
                </div>

                <div className="pt-1">
                    {selectedTab === 'COMPANY_CODES' && (
                        <div>
                            <CompanyComponent />
                        </div>
                    )}
                    {selectedTab === 'ADMIN_USERS' && (
                        <div>
                            <AdminUserManagement />
                        </div>
                    )}

                    {selectedTab === 'CLIENT_ID_MANAGEMENT' && (
                        <div>
                            <ClientIdManagament />
                        </div>
                    )}

                    {selectedTab === 'LOCATION_SETTINGS' && (
                        <div>
                            <LocationSettings />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LlAdmin;
